export const articleKeys = {
    detail: (articleId: string) => ['article', articleId] as const,
};
